import { render } from "./GridRoluri.vue?vue&type=template&id=910338c4&scoped=true&ts=true"
import script from "./GridRoluri.vue?vue&type=script&lang=ts"
export * from "./GridRoluri.vue?vue&type=script&lang=ts"

import "./GridRoluri.vue?vue&type=style&index=0&id=910338c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-910338c4"]])

export default __exports__